import {createContext,useContext} from "react";
interface AiCoachContextValue {
  open: boolean;
  pendingPrompt: string | null;
  openCoach: (prompt?: string) => void;
  closeCoach: () => void;
  clearPrompt: () => void;
}

export const AiCoachContext = createContext<AiCoachContextValue | null>(null);

export function useAiCoach(): AiCoachContextValue {
  const ctx = useContext(AiCoachContext);
  if (!ctx) {
    throw new Error("useAiCoach must be used within AiCoachProvider");
  }
  return ctx;
}